import { useEffect, useRef } from 'react';
import setNativeProperty from '../lib/setNativeProperty';

const useFileUpload = (filePath) => {
  const ref = useRef();

  useEffect(() => {
    if (filePath === undefined || filePath === null) {
      return;
    }

    setNativeProperty(ref.current, filePath);
    ref.current.dispatchEvent(new Event('change', { bubbles: true }));
  }, [filePath]);

  return ref;
};

export default useFileUpload;
